import { createSlice } from '@reduxjs/toolkit';

import { leisurePurchaseSteps } from 'constants';

const initialState = () => {
  return {
    /**
     * Steps of the leisure purchase process
     * @type {Array<{slug: string, order: number, label: string, current: boolean, valid: boolean, completed: boolean}>}
     */
    steps: leisurePurchaseSteps,
    /**
     * Shipping method for all products (except mandatory e-tickets)
     * @type {string|null}
     */
    shippingMethod: null,
    /**
     * Selected newsletter in Validation Step
     * @type {boolean}
     */
    newsletter: false,
    /**
     * Shipping price in cents: includes all types of shipping (e.g. e-ticket, registered_mail, etc.)
     */
    shippingPrice: 0,
    /**
     * Selected subvention in Validation Step
     * @type {number|null}
     * if null, no subvention is selected. Otherwise, it is the amount of the subvention
     */
    subvention: null,
    /**
     * Selected depositChoice in Validation Step
     * @type {string|null}
     */
    depositChoice: null,
    /**
     * Selected depositAmount in Validation Step
     * @type {number|null}
     */
    depositAmount: null,
    /**
     * Selected paymentMethod in Validation Step
     * @type {string|null}
     */
    paymentMethod: null,
    /**
     * Payment head (script and css link) and body (payzen form) for the payment page with credit card
     * @type {string|null}
     */
    paymentHead: null,
    paymentBody: null
  };
};

export const leisurePurchase = createSlice({
  name: 'leisurePurchase',
  initialState: { ...initialState() },
  reducers: {
    setLeisurePurchase: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setLeisureSteps: (state, action) => {
      const { stepToUpdate, targetStep } = action.payload;
      const currentStepIndex = state.steps.findIndex((step) => step.slug === stepToUpdate.slug);
      const targetStepIndex = state.steps.findIndex((step) => step.slug === targetStep.slug);

      if (state.steps?.[currentStepIndex]) state.steps[currentStepIndex].current = false;
      if (state.steps?.[targetStepIndex]) state.steps[targetStepIndex].current = true;
    },
    updateCurrentLeisureStepValidity: (state, action) => {
      const { valid, completed } = action.payload;
      const currentStepIndex = state.steps.findIndex((step) => step.current);
      if (currentStepIndex === -1) return;
      state.steps[currentStepIndex].valid = valid;
      state.steps[currentStepIndex].completed = completed;
    },
    resetLeisurePurchaseStore: (state) => {
      Object.assign(state, initialState());
    }
  }
});

export const { setLeisurePurchase, setLeisureSteps, updateCurrentLeisureStepValidity, resetLeisurePurchaseStore } =
  leisurePurchase.actions;
export default leisurePurchase.reducer;
